import { render, staticRenderFns } from "./vx_tabulator.vue?vue&type=template&id=77f13801&scoped=true&"
import script from "./vx_tabulator.vue?vue&type=script&lang=js&"
export * from "./vx_tabulator.vue?vue&type=script&lang=js&"
import style0 from "./vx_tabulator.vue?vue&type=style&index=0&id=77f13801&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f13801",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('77f13801', component.options)
    } else {
      api.reload('77f13801', component.options)
    }
    module.hot.accept("./vx_tabulator.vue?vue&type=template&id=77f13801&scoped=true&", function () {
      api.rerender('77f13801', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/vx_tabulator.vue"
export default component.exports